import { createRouter, createWebHistory } from 'vue-router';
import { useBusyStore } from '@store/busy';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(_to, _from, savedPosition) {
    return savedPosition || { left: 0, top: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@pages/HomePage.vue'),
    },
    {
      path: '/dealers',
      name: 'dealers-list',
      component: () => import('@modules/dealers/pages/DealersList.vue'),
    },
    {
      path: '/dealers-bulk-modules',
      name: 'dealers-bulk-modules',
      component: () => import('@modules/dealers/pages/DealersBulkModules.vue'),
      meta: {
        breadcrumbs: [{ name: 'dealers-list', labelKey: 'NAV.dealers' }],
      },
    },
    {
      path: '/dealers-detail/:dealerId',
      name: 'dealer-detail',
      props: true,
      component: () => import('@modules/dealers/pages/DealerDetail.vue'),
      meta: {
        breadcrumbs: [{ name: 'dealers-list', labelKey: 'NAV.dealers' }],
      },
    },
    {
      path: '/dealers-detail/:dealerId/edit',
      name: 'dealer-edit',
      redirect: (to) => ({ name: 'dealer-detail', params: { dealerId: to.params.dealerId } }),
    },
    {
      path: '/dealers-detail/:dealerId/pbx',
      name: 'dealer-pbx',
      props: true,
      component: () => import('@modules/dealers/pages/DealerPbx.vue'),
      meta: {
        breadcrumbs: [
          { name: 'dealers-list', labelKey: 'NAV.dealers' },
          { name: 'dealer-detail', labelParam: 'dealerId' },
        ],
      },
    },
    {
      path: '/dispatchers',
      name: 'dispatchers-list',
      component: () => import('@modules/dispatchers/pages/DispatchersList.vue'),
    },
    {
      path: '/dispatchers-detail/:dispatcherId',
      name: 'dispatcher-detail',
      props: true,
      component: () => import('@modules/dispatchers/pages/DispatcherDetail.vue'),
      meta: {
        breadcrumbs: [{ name: 'dispatchers-list', labelKey: 'NAV.dispatchers' }],
      },
    },
    {
      path: '/templates',
      name: 'templates-list',
      component: () => import('@modules/templates/pages/TemplatesList.vue'),
    },
    {
      path: '/templates-detail/:templateName',
      name: 'template-detail',
      props: true,
      component: () => import('@modules/templates/pages/TemplateDetail.vue'),
    },
    {
      path: '/templates-add',
      name: 'template-add',
      component: () => import('@modules/templates/pages/TemplateEdit.vue'),
    },
    {
      path: '/templates-detail/:templateName/edit',
      name: 'template-edit',
      props: true,
      component: () => import('@modules/templates/pages/TemplateEdit.vue'),
    },
    {
      path: '/import-flow',
      name: 'import-flow-dealer-list',
      component: () => import('@modules/import-flow/pages/DealerImportList.vue'),
    },
    {
      path: '/import-flow-detail/:dealerId',
      name: 'import-flow-dealer-phases',
      props: true,
      component: () => import('@modules/import-flow/pages/DealerFlowPhasesList.vue'),
    },
    {
      path: '/import-flow-detail/:dealerId/:flowName',
      name: 'import-flow-dealer-flows',
      props: true,
      component: () => import('@modules/import-flow/pages/DealerFlowIdList.vue'),
    },
    {
      path: '/import-flow-detail/:dealerId/:flowName/:flowId/:component',
      name: 'import-flow-dealer-messages',
      props: true,
      component: () => import('@modules/import-flow/pages/DealerFlowMessageList.vue'),
    },
    {
      path: '/dms-integration',
      name: 'dms-integration-dealer-list',
      component: () => import('@modules/dms-integration/pages/DealersList.vue'),
    },
    {
      path: '/401',
      name: 'unauthorized',
      component: () => import('@pages/ErrorPage.vue'),
      props: { type: '401' },
    },
    {
      path: '/403',
      name: 'forbidden',
      component: () => import('@pages/ErrorPage.vue'),
      props: { type: '403' },
    },
    {
      path: '/500',
      name: 'server-error',
      component: () => import('@pages/ErrorPage.vue'),
      props: { type: '500' },
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'page-404',
      component: () => import('@pages/ErrorPage.vue'),
      props: { type: '404' },
    },
  ],
});

router.beforeEach(() => {
  useBusyStore().start();
});

router.afterEach(() => {
  useBusyStore().stop();
});

export default router;
